export default "__VITE_ASSET__d77752a4__"